export default __webpack_public_path__ + "static/media/error.0a7a5644.svg";